export default __webpack_public_path__ + "static/media/716.76d7d848.png";